import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showWelcomeModal: false,
  showUserRegisterModal: false,
  showUserLoginModal: false,
  showUserDepositModal: false,
  showUserWithdrawModal: false,
  showUserNotification: false,
  showForgotPassword: false,
  showPagoEfectivo: false,
  showPayRetailer: false,
  showUserMenuMobile: false,
  showInfoModal: false,
  ShowPagoFacil: false,
  ShowYape: false,
  showBonos: false,
  dontShowAgainModalInfo: false,
  urlPagoEfectivo: "",
  urlPayRetailer: "",
  QRpagofacil: "",
  IdTransYape: "",
  mensaje:"",
  esperando: "",
  Anulado: false,
  Minimo:"",
  Urlverify: "",
  ShowJumio: false,
  urlKushki: "",
  showKushki: false,
  urlAlps: "",
  showAlps: false,
};

const modalsSlice = createSlice({
  name: "modals",
  initialState,
  reducers: {
    setShowWelcomeModal: (state, action) => {
      state.showWelcomeModal = action.payload;
    },
    setShowUserRegisterModal: (state, action) => {
      state.showUserRegisterModal = action.payload;
    },
    setShowUserLoginModal: (state, action) => {
      state.showUserLoginModal = action.payload;
    },
    setShowUserDepositModal: (state, action) => {
      state.showUserDepositModal = action.payload.open;
      state.showUserWithdrawModal = action.payload.type;
    },
    setShowUserWithdrawModal: (state, action) => {
      state.showUserWithdrawModal = action.payload;
    },
    setShowUserNotification: (state, action) => {
      state.showUserNotification = action.payload;
    },
    setShowForgotPassword: (state, action) => {
      state.showForgotPassword = action.payload;
    },
    setShowPagoEfectivo: (state, action) => {
      state.showPagoEfectivo = action.payload;
    },
    setUrlPagoEfectivo: (state, action) => {
      state.urlPagoEfectivo = action.payload;
    },
    setShowPagoFacil: (state, action) => {
      state.ShowPagoFacil = action.payload;
    },
    setQRPagofacil: (state, action) => {
      state.QRpagofacil = action.payload;
    },
    setShowYape: (state, action) => {
      state.ShowYape = action.payload;
    },
    setAnulado: (state, action) => {
      state.Anulado = action.payload;
    },
    setIdTransYape: (state, action) => {
      state.IdTransYape = action.payload;
    },
    setMinimo: (state, action) => {
      state.Minimo = action.payload;
    },
    setmensaje: (state, action) => {
      state.mensaje = action.payload;
    },
     setesperando: (state, action) => {
      state.esperando = action.payload;
    },
    setShowUserMenuMobile: (state, action) => {
      state.showUserMenuMobile = action.payload;
    },
    setShowUserBonos: (state, action) => {
      state.showBonos = action.payload;
    },
    setShowPayRetailer: (state, action) => {
      state.showPayRetailer = action.payload;
    },
    setUrlPayRetailer: (state, action) => {
      state.urlPayRetailer = action.payload;
    },
    setShowInfoModal: (state, action) => {
      state.showInfoModal = action.payload;
    },
    setDontShowAgainInfoModal: (state, action) => {
      state.dontShowAgainModalInfo = action.payload;
    },
    setShowOtherModal: (state, action) => {
      state.showOtherModal = action.payload;
    },
    setUrlverify: (state, action) => {
      state.Urlverify = action.payload;
    },
    setShowJumio: (state, action) => {
      state.ShowJumio = action.payload;
    },
    setShowKushki: (state, action) => {
      state.showKushki = action.payload;
    },
    setUrlKushki: (state, action) => {
      state.urlKushki = action.payload;
    },
    setShowAlps: (state, action) => {
      state.showAlps = action.payload;
    },
    setUrlAlps: (state, action) => {
      state.urlAlps = action.payload;
    },
  },
});

export const {
  setShowUserRegisterModal,
  setShowWelcomeModal,
  setShowUserLoginModal,
  setShowUserDepositModal,
  setShowUserWithdrawModal,
  setShowUserNotification,
  setShowForgotPassword,
  setShowPagoEfectivo,
  setUrlPagoEfectivo,
  setShowUserMenuMobile,
  setShowUserBonos,
  setShowPayRetailer,
  setUrlPayRetailer,
  setShowInfoModal,
  setDontShowAgainInfoModal,
  setShowOtherModal,
  setShowPagoFacil,
  setQRPagofacil,
  setShowYape,
  setIdTransYape,
  setMinimo,
  setmensaje,
  setesperando,
  setAnulado,
  setUrlverify,
  setShowJumio,
  setShowKushki,
  setUrlKushki,
  setShowAlps,
  setUrlAlps,
} = modalsSlice.actions;

export const selectWelcomeModal = (state) => state.modals.showWelcomeModal;
export const selectDepositModal = (state) => state.modals.showUserDepositModal;
export const selectWithdrawModal = (state) =>
  state.modals.showUserWithdrawModal;
export const selectRegisterModal = (state) =>
  state.modals.showUserRegisterModal;
export const selectLoginModal = (state) => state.modals.showUserLoginModal;
export const selectNotificationModal = (state) =>
  state.modals.showUserNotification;
export const selectForgotPasswordModal = (state) =>
  state.modals.showForgotPassword;

/** info modal */
export const selectInfoModal = (state) => state.modals.showInfoModal;
export const selectDontShowAgain = (state) =>
  state.modals.dontShowAgainModalInfo;
/** info modal */

export const selectUrlPagoEfectivo = (state) => state.modals.urlPagoEfectivo;
export const selectPagoEfectivoModal = (state) => state.modals.showPagoEfectivo;
export const selectQRPagoFacil = (state) => state.modals.QRpagofacil;
export const selectPagoFacilModal = (state) => state.modals.ShowPagoFacil;
export const selectIdTrans = (state) => state.modals.IdTransYape;
export const selectMinimo = (state) => state.modals.Minimo;
export const selectmensaje = (state) => state.modals.mensaje;
export const selectesperando = (state) => state.modals.esperando;
export const selectYapeModal = (state) => state.modals.ShowYape;
export const selectAnulado = (state) => state.modals.Anulado;
export const selectUrlPayRetailer = (state) => state.modals.urlPayRetailer;
export const selectPayRetailerModal = (state) => state.modals.showPayRetailer;
export const selectOtherModal = (state) => state.modals.showOtherModal;
export const selectShowUserMenuMobile = (state) =>
  state.modals.showUserMenuMobile;
export const selectUserBonos = (state) => state.modals.showBonos;
export const selectUrlverify = (state) => state.modals.Urlverify;
export const selectJumioModal = (state) => state.modals.ShowJumio;
export const selectUrlKushki = (state) => state.modals.urlKushki;
export const selectKuskiModal = (state) => state.modals.showKushki;
export const selectUrlAlps = (state) => state.modals.urlAlps;
export const selectAlpsModal = (state) => state.modals.showAlps;

export default modalsSlice.reducer;
